<template>
    <div class="toast" role="alert" aria-live="assertive" aria-atomic="true" ref="toast_el">
        <div class="toast-header">
            
            <strong class="me-auto">{{ titulo }}</strong>
            <small>{{ tempo }}</small>
            <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>
        </div>
        <div class="toast-body">
            {{ body }}
        </div>
    </div>
</template>
<script setup lang="ts">
import { computed, onMounted, onUnmounted, onUpdated, ref } from 'vue';
import { Toast } from 'bootstrap'
import { timeElapsed } from '@/lib/time-elapsed'
import { now } from '@/store/now';

const toast_el = ref<HTMLDivElement|null>(null)
const toast = ref<Toast | null>(null)

interface Props {
    titulo: string,
    started_at: Date,
    body: string
}

const props = defineProps<Props>()

const tempo = computed(() => {
    
    return timeElapsed(props.started_at, now.value)
})

onMounted(() => {
    if (!toast_el.value) {
        return
    }
    toast.value = new Toast(toast_el.value, {
        autohide: false
    })
    toast.value.show()
})

onUnmounted(() => {
    if (!toast.value) {
        return
    }
    toast.value.dispose()
})

onUpdated(() => {
    /*
    if (toast.value) {
        toast.value.dispose()
    }
    if (!toast_el.value) {
        return
    }
    toast.value = new Toast(toast_el.value, {
        autohide: false
    })
    toast.value.show()
    */
})
</script>